/**
 * The team: who works here, and the hours they clock.
 *
 * Both of these used to live only inside Settings, which sits on its own at
 * the bottom of the sidebar — "I can't find settings 🤔". Staff and a time
 * clock are things you MANAGE, so they belong beside the menu, the forms and
 * the automations, which is where she already goes to change how the practice
 * runs. The same sections still appear in Settings; this is a second door,
 * not a move.
 */
import { Section, StaffSection } from "./SettingsPage";
import { Timesheet } from "@/features/timeclock/Timesheet";
import { ClockRoster } from "@/features/timeclock/ClockRoster";

export function TeamPage() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-semibold text-zinc-100 sm:text-2xl">Team</h1>
        <p className="mt-1 text-sm text-zinc-500">
          Everyone who works here, what they can open, and the hours they clock.
        </p>
      </div>

      <StaffSection />

      <Section title="Who is on">
        <p className="mb-3 text-xs text-zinc-500">
          Clock anybody in or out from here. Staff can still do their own from the front
          desk - a shift somebody else started or ended records who did it, because that
          is a different fact from doing it yourself if it is ever questioned.
        </p>
        <ClockRoster />
      </Section>

      <Section title="Time clock">
        <p className="mb-3 text-xs text-zinc-500">
          What those hours add up to - the totals are what a pay run needs, and the shifts
          underneath are what you check when somebody disagrees. A shift corrected here
          keeps its original times and your name against the change.
        </p>
        <Timesheet />
      </Section>
    </div>
  );
}
